<div
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
  class="notification-card"
>
  <div class="notification-card-text">
    <ng-content></ng-content>
  </div>
</div>
